import script from "./TableHistorialComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHistorialComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableHistorialComponent.vue?vue&type=style&index=0&id=707ec8b6&lang=css"

const __exports__ = script;

export default __exports__